export enum ProductEnum {
  MONTHLY = "premium.monthly",
  ANNUALLY = "premium.annually",
}

export enum ProductPriceEnum {
  MONTHLY = "4.99",
  ANNUALLY = "44.99",
}
